import axios from 'axios';

// const url = "http://localhost/cenfotep/server/cenfotep/public"
const url = "https://server.cenfotep.org/public";


const api = axios.create({
    baseURL: url,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default api;